import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { cache } from '@clearscore/helpers.cache';
import device from '@clearscore/helpers.device';

// eslint-disable-next-line import/no-mutable-exports
const fingerprint = {
    component: [],
    hash: 'server',
    calculate: function fingerprintPromise() {
        return FingerprintJS.load()
            .then((fp) => fp.get())
            .then((components) => components.visitorId);
    },
};

(async () => {
    const fp = await FingerprintJS.load();
    const results = await fp.get();

    const {
        colorDepth,
        screenResolution,
        availableScreenResolution,
        plugins,
        fonts,
        canvas,
        audio,
        touchSupport,
        ...components
    } = results.components;

    const extendedComponents = {
        ...components,
        osAndBrowser: { value: device.DEVICE_NAME },
    };

    const visitorId = FingerprintJS.hashComponents(extendedComponents);

    fingerprint.hash = visitorId;
    fingerprint.components = extendedComponents;
    cache.device = {
        hash: fingerprint.hash,
        components: fingerprint.components,
    };
})();

export default fingerprint;
